import { Platform } from "@src/mobile/utils/platform";

/**
 * Writes a string to the native clipboard via Capacitor.
 * No-op on web — callers must fall back to the browser Clipboard API themselves
 * (see `src/appV2/redesign/utils/copyToClipboard.ts` for the canonical fallback chain).
 */
export async function writeToClipboard(text: string): Promise<void> {
  if (!Platform.isMobile) {
    return;
  }

  const { Clipboard } = await import("@capacitor/clipboard");
  await Clipboard.write({ string: text });
}
